type ClassValues = Array<string | undefined | null | false>;
/**
 * Represents a series of classNames.
 * Concatenates all its arguments to a single string.
 * Filters out null, undefined and false values.
 * @example
 * let isActive = false;
 * cn("color-red-500 bg-red-100", "text-lg font-bold", isActive && "opacity-100")
 * // returns "color-red-500 bg-red-100 text-lg font-bold"
 */
export function cn(...classnames: ClassValues): string {
  let result = "";
  for (const c of classnames) {
    if (c) result += " " + c;
  }
  return result.trim();
}
